// @ts-nocheck
import { authenticated, api } from './index';

export const createCostCode = (payload) =>
  authenticated(api).post('/settings_cost_codes/', payload);

export const getCostCodes = (params) =>
  authenticated(api).get('/settings_cost_codes/', { params });

export const updateCostCode = (params, payload) =>
  authenticated(api).put(`/settings_cost_codes/${params.costCodeId}/`, payload);

export const deleteCostCode = (payload) =>
  authenticated(api).delete(`v1.1/accounting-code/bulk_archive/`, {
    data: payload,
  });

export const createNote = (payload) =>
  authenticated(api).post('/settings_cost_code_notes/', payload);

export const updateNote = (params, payload) =>
  authenticated(api).put(
    `/settings_cost_code_notes/${params.noteId}/`,
    payload,
  );

export const deleteNote = (params) =>
  authenticated(api).delete(`/settings_cost_code_notes/${params.noteId}/`);

export const exportCostCode = () =>
  authenticated(api).post('/settings_cost_codes/create_cost_code_export/');

export const getSampleCostCode = () =>
  authenticated(api).get('/settings_cost_codes/sample_template_url/');

export const getSystemFields = () =>
  authenticated(api).get('/settings_cost_codes/column_headers/');

export const checkUnidentifiedCategories = (payload) =>
  authenticated(api).post(
    '/settings_cost_codes/check_unidentified_categories/',
    payload,
  );

export const saveBulkCostCodes = (payload) =>
  authenticated(api).post('/settings_cost_codes/save_cost_codes/', payload);

export const checkDefaultCategory = () =>
  authenticated(api).get('settings_cost_codes/has_default_category/');
